import React from 'react';
import { Form, Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import styles from './inputField.module.scss';

const InputField = (props) => {
  const {
    name,
    label,
    type = 'text',
    placeholder,
    rules,
    form,
    iconRender = (visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />),
    className,
    ...restProps
  } = props;

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      className={`${styles.formItem} ${className || ''}`}
      validateTrigger="onBlur"
    >
      {type === 'password' ? (
        <Input.Password
          placeholder={placeholder}
          iconRender={iconRender}
          className={styles.input}
          {...restProps}
        />
      ) : (
        <Input type={type} placeholder={placeholder} className={styles.input} {...restProps} />
      )}
    </Form.Item>
  );
};

export default InputField;
